export const DATA = {
  "Skill level": "Beginner",
  "Time to complete": "Approx. 36 hours",
  Certificate: "Included",
  Prerequesties: "None",
  description: "Build Strong Coding Foundations from Scratch",
  about:
    "Build a strong programming foundation with C and C++. Learn coding logic, object-oriented concepts, and essential data structures-preparing you for software development, competitive coding, and solving real-world computational problems efficiently.",
  skills: ["Logical Reasoning", "Problem Solving", "Competitive Programming"],
  reviews: {
    1: {
      name: "Aarav S",
      review:
        "This course gave me a clear understanding of C and C++. The explanations for pointers and memory allocation were incredibly well done. The Data Structures section helped me build a much stronger foundation for competitive programming.",
    },
    2: {
      name: "Lena M",
      review:
        "I struggled with C before, but this course simplified everything. The instructor explains concepts with real examples, especially linked lists and trees. Very practical and well-paced.",
    },
    3: {
      name: "Rohit N",
      review:
        "A very thorough course! The algorithms section was especially helpful for my interview preparations. The assignments were challenging but extremely rewarding.",
    },
    4: {
      name: "Jasmine P",
      review:
        "I loved how every concept was broken down. From arrays to graphs, everything was taught in a very understandable way. Perfect for beginners.",
    },
    5: {
      name: "Daniel H",
      review:
        "The best part of this course is the step-by-step approach. Complex topics like dynamic memory and recursion were made surprisingly easy to grasp.",
    },
    6: {
      name: "Pratik V",
      review:
        "The instructor explains the logic behind data structures so clearly. I now understand how and when to use each structure effectively.",
    },
    7: {
      name: "Zara F",
      review:
        "Amazing course! The C and C++ basics are covered thoroughly, and the Data Structures segments are great for academic and professional learning.",
    },
    8: {
      name: "Michael B",
      review:
        "Very detailed and well-organized. I especially enjoyed the sorting and searching algorithm explanations. They were clear and visual.",
    },
    9: {
      name: "Harsha K",
      review:
        "This course helped me overcome my fear of pointers. Everything is explained step-by-step with logical examples. Highly recommended!",
    },
    10: {
      name: "Saanvi R",
      review:
        "The exercises in this course really helped me understand recursion and tree traversal. The difficulty level was perfect.",
    },
    11: {
      name: "Khalid A",
      review:
        "Fantastic course! I finally feel confident writing efficient C/C++ code and understanding how data structures work under the hood.",
    },
    12: {
      name: "Emily W",
      review:
        "Perfect for beginners and intermediates. The instructor makes sure you understand every small detail before moving forward.",
    },
    13: {
      name: "Yash D",
      review:
        "I loved how practical the course was. Implementing stacks, queues, and trees really built my confidence as a programmer.",
    },
    14: {
      name: "Nina V",
      review:
        "The explanations were simple but powerful. I appreciate the clarity and completeness of the course content.",
    },
    15: {
      name: "Omar L",
      review:
        "This course has prepared me extremely well for technical interviews. The algorithm complexity explanations were top-notch.",
    },
    16: {
      name: "Grace T",
      review:
        "The lessons are very well structured. The instructor teaches C and C++ concepts in the smoothest way possible.",
    },
    17: {
      name: "Ishan M",
      review:
        "I really enjoyed learning about graphs and trees. The examples were practical and easy to understand.",
    },
    18: {
      name: "Hannah J",
      review:
        "Clear, concise, and extremely helpful. I never thought I’d understand memory management this well!",
    },
    19: {
      name: "Leonard P",
      review:
        "This is the perfect foundational course for anyone getting into software development. The logic-building exercises were amazing.",
    },
    20: {
      name: "Ritika S",
      review:
        "The best part of this course is how everything is connected. Each concept builds on the previous one smoothly.",
    },
    21: {
      name: "Adrian C",
      review:
        "Great for learning the fundamentals properly. The teaching style is calm, detailed, and easy to follow.",
    },
    22: {
      name: "Fatima N",
      review:
        "I appreciated how the instructor explained every data structure with diagrams. It made understanding so much easier.",
    },
    23: {
      name: "Vikram J",
      review:
        "The coding assignments were realistic and interesting. They helped me deeply understand how data structures work.",
    },
    24: {
      name: "Sophia K",
      review:
        "Everything felt well-planned and polished. I especially liked the explanation of object-oriented concepts in C++.",
    },
    25: {
      name: "Marcus R",
      review:
        "A brilliant introductory-to-advanced course. It strengthened my basics and improved my problem-solving skills tremendously.",
    },
  },

  modules: {
    "Fundamentals of C Programming": [
      "Installation and Environment Setup.",
      "Basic Syntax, Data Types, Variables, and Operators.",
      "Conditional Statements and Looping Constructs.",
      "Arrays, Strings, and Memory Storage.",
      "Pointers and Memory Management.",
    ],
    "Advanced C Programming": [
      "Structures and Unions.",
      "File Handling Techniques.",
      "Dynamic Memory Allocation (malloc, calloc).",
      "Command-Line Arguments.",
      "Modular Programming & Header Files.",
    ],
    "Object-Oriented Programming with C++": [
      "Classes, Objects, Constructors and Inheritance.",
      "Inline and Virtual Functions, Polymorphism, Function & Operator Overloading.",
      "Encapsulation and Abstraction.",
      "STL (Vectors, Lists, Maps).",
      "Exception Handling in C++.",
    ],
    "Data Structures Essentials": [
      "Arrays, Linked Lists, Stacks and Queues.",
      "Trees, Binary Trees, Searching and Sorting Methods.",
      "Recursion and Backtracking.",
      "Priority Queues & Heaps.",
      "Tree Traversal Techniques.",
      "Mini Project 1 - Library Management System (Using Linked Lists & Queues).",
    ],
    "Algorithms & Problem Solving + Mini Projects": [
      "Time & Space Complexity Analysis.",
      "Searching & Sorting Techniques.",
      "Introduction to Graph Algorithms.",
      "Hashing & Hash Tables.",
      "Problem Solving Strategies.",
      "Competitive Coding Challenges.",
      "Mini Project 2 - Student Record Management System.",
      "Mini Project 3 - Inventory Management System.",
      "Mini Project 4 - Custom Search Engine (Basic Version).",
    ],
  },
};
